// extracted by mini-css-extract-plugin
export default {"wrapper":"parallax-group_wrapper__hFPZg","about":"parallax-group_about__1SVXw","work":"parallax-group_work__zV+PM","contact":"parallax-group_contact__1YOmP"};